export interface IPreviousEdition {
  title: String;
  published: string;
  edition: String;
  Addenda: String[];
  Errata: String[];
  amendments: Array<IAmendments>;
  languages: String[];
}

export interface IAmendments {
  name: string;
  number: string;
  amendmentType: string;
  publishedDate: string;
}

export interface PreviousEdition {
  PreviousEditionDetails: IPreviousEdition;
}
export default {};
